// Import React Library
import React, { Fragment } from "react"
import Header from "../../components/header"
import Footer from "../../components/footer"

const AnyReactComponent = ({ text }) => (
    <div style={{
        fontSize: "26px",
        color: "#3ec2cf",
        padding: "5px 5px",
        display: "inline-flex",
        textAlign: "center",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "5px",
        transform: "translate(-50%, -50%)",
    }}>{text}</div>
)

export default class ContactsPage extends React.Component {
    static defaultProps = {
        center: { lat: 50.5563545, lng: 26.2434566 },
        zoom: 15,
    }

    componentDidMount() {
        document.title = `Замовити ковбасну та м'ясну продукцію оптом та в роздріб Україна Миході Рівне`
        document.getElementsByTagName(
            "META")[3].content = `Миходi Рівне замовити ковбасну та м'ясну продукцію з доставкою у Луцьк, Київ, Хмельницьк, Житомир, Тернопіль, Львів, Ужгород, Івано-Франківськ, Вінницю`
        document.getElementsByTagName("META")[4].content = `контактні дані миході рівне, миході у соціальних мережах, офіційний сайт миході, замовити ковбасу, купити ковбасу, графік роботи миході`
    }

    render() {

        return (
            <Fragment>
                <Header />
                <div className="container">

                    <div className="contacts" itemScope itemType="http://schema.org/Organization">
                        <div className="row">
                            <div className="col">
                                <h2 className={"text-center"}>Ми в соціальних мережах:</h2>
                                <div className="socials">
                                    <div className="viber">
                                        <svg width="42" height="42" viewBox="0 0 42 42" fill="#E8E0D3"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M4.99943 33.0012L5.89385 33.4484L6.17049 32.8951L5.79895 32.4005L4.99943 33.0012ZM8.99885 37.0006L9.59949 36.2011L9.10492 35.8295L8.55164 36.1062L8.99885 37.0006ZM1 41L0.105573 40.5528C-0.0869215 40.9378 -0.011467 41.4028 0.292893 41.7071C0.597253 42.0115 1.06222 42.0869 1.44721 41.8944L1 41ZM13 13L12.4 12.2C12.1482 12.3889 12 12.6853 12 13H13ZM29 29V30C29.295 30 29.5749 29.8698 29.7649 29.6442L29 29ZM14.2429 12.0678L13.6429 11.2678L14.2429 12.0678ZM17.4275 13.4198L16.4352 13.5438L17.4275 13.4198ZM17.8787 17.0294L18.871 16.9054L17.8787 17.0294ZM17.3083 18.6917L16.6012 17.9846V17.9846L17.3083 18.6917ZM29.8866 27.9472L29.1217 27.303L29.8866 27.9472ZM28.6464 24.68L28.7912 23.6905L28.6464 24.68ZM24.9937 24.1454L25.1385 23.156L24.9937 24.1454ZM23.2899 24.7101L23.997 25.4173L23.2899 24.7101ZM2.44379e-05 21C2.44379e-05 25.7269 1.56299 30.0917 4.1999 33.6018L5.79895 32.4005C3.4133 29.2249 2.00002 25.2789 2.00002 21H2.44379e-05ZM21 0C9.40205 0 2.44379e-05 9.40202 2.44379e-05 21H2.00002C2.00002 10.5066 10.5066 2 21 2V0ZM42 21C42 9.40202 32.598 0 21 0V2C31.4934 2 40 10.5066 40 21H42ZM21 42C32.598 42 42 32.598 42 21H40C40 31.4934 31.4934 40 21 40V42ZM8.39821 37.8001C11.9083 40.437 16.2731 42 21 42V40C16.7211 40 12.7751 38.5867 9.59949 36.2011L8.39821 37.8001ZM1.44721 41.8944L9.44606 37.895L8.55164 36.1062L0.552787 40.1056L1.44721 41.8944ZM4.105 32.5539L0.105573 40.5528L1.89443 41.4472L5.89385 33.4484L4.105 32.5539ZM12 13V15H14V13H12ZM27 30H29V28H27V30ZM12 15C12 23.2843 18.7157 30 27 30V28C19.8203 28 14 22.1797 14 15H12ZM13.6 13.8L14.8429 12.8678L13.6429 11.2678L12.4 12.2L13.6 13.8ZM16.4352 13.5438L16.8864 17.1534L18.871 16.9054L18.4197 13.2957L16.4352 13.5438ZM16.6012 17.9846L14.2929 20.2929L15.7071 21.7071L18.0154 19.3988L16.6012 17.9846ZM16.8864 17.1534C16.9247 17.4596 16.8194 17.7664 16.6012 17.9846L18.0154 19.3988C18.6701 18.7442 18.9858 17.824 18.871 16.9054L16.8864 17.1534ZM14.8429 12.8678C15.4572 12.4071 16.34 12.7819 16.4352 13.5438L18.4197 13.2957C18.134 11.0101 15.4857 9.88576 13.6429 11.2678L14.8429 12.8678ZM29.7649 29.6442L30.6515 28.5913L29.1217 27.303L28.2351 28.3559L29.7649 29.6442ZM28.7912 23.6905L25.1385 23.156L24.8489 25.1349L28.5016 25.6694L28.7912 23.6905ZM22.5828 24.003L20.2929 26.2929L21.7071 27.7071L23.997 25.4173L22.5828 24.003ZM25.1385 23.156C24.2006 23.0187 23.253 23.3328 22.5828 24.003L23.997 25.4173C24.2204 25.1938 24.5363 25.0891 24.8489 25.1349L25.1385 23.156ZM30.6515 28.5913C32.1658 26.7931 31.1173 24.0309 28.7912 23.6905L28.5016 25.6694C29.277 25.7829 29.6265 26.7036 29.1217 27.303L30.6515 28.5913Z"
                                                fill="#E8E0D3" />
                                        </svg>
                                    </div>
                                    <div className="instagram">
                                        <svg width="37" height="38" viewBox="0 0 37 38" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M27.7142 10.4285H29.4285M7.9999 1.85712H28.5713C32.3584 1.85712 35.4285 4.92716 35.4285 8.71426V29.2857C35.4285 33.0728 32.3584 36.1428 28.5713 36.1428H7.9999C4.21281 36.1428 1.14276 33.0728 1.14276 29.2857V8.71426C1.14276 4.92716 4.21281 1.85712 7.9999 1.85712ZM18.2856 25.8571C14.4985 25.8571 11.4285 22.7871 11.4285 19C11.4285 15.2129 14.4985 12.1428 18.2856 12.1428C22.0727 12.1428 25.1428 15.2129 25.1428 19C25.1428 22.7871 22.0727 25.8571 18.2856 25.8571Z"
                                                stroke="#E8E0D3" strokeWidth="2" />
                                        </svg>
                                    </div>
                                    <div className="telegram">
                                        <svg width="38" height="32" viewBox="0 0 38 32" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M36.1428 1.42859L1.85712 13.6735L11.653 18.5714L26.3469 8.77553L16.551 21.0204L31.2449 30.8163L36.1428 1.42859Z"
                                                stroke="#E8E0D3" strokeWidth="2" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                    <div className="facebook">
                                        <svg width="38" height="38" viewBox="0 0 38 38" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M19 36.1428C9.53224 36.1428 1.85712 28.4677 1.85712 19C1.85712 9.53224 9.53224 1.85712 19 1.85712C28.4677 1.85712 36.1428 9.53224 36.1428 19C36.1428 28.4677 28.4677 36.1428 19 36.1428ZM19 36.1428V15.5714C19 13.6779 20.535 12.1428 22.4285 12.1428H25M13 22.4285H25"
                                                stroke="#E8E0D3" strokeWidth="2" />
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="contacts" itemScope itemType="http://schema.org/Organization">
                        <div className="row">
                            <div className="col-sm">
                                <span itemProp="name">тм МИХОДI</span>
                                <div itemProp="address" itemScope itemType="http://schema.org/PostalAddress">
                                    {process.env.REACT_APP_CONTACT_COUNTRY} &#8194;
                                    <span itemProp="addressRegion">{process.env.REACT_APP_CONTACT_REGION}</span> обл.
                                    <br />
                                    <span itemProp="postalCode">{process.env.REACT_APP_CONTACT_CODE}</span> &#8194;
                                    <span
                                        itemProp="addressLocality">{process.env.REACT_APP_CONTACT_LOCALITY}</span> &#8194;
                                    <br />
                                    <span itemProp="streetAddress">{process.env.REACT_APP_CONTACT_ADRESS}</span>
                                </div>
                            </div>
                            <div className="col-sm">
                                Телефони
                                <br /><br />
                                <span itemProp="telephone">{process.env.REACT_APP_PHONE1}</span>
                            </div>
                            <div className="col-sm">
                                Email
                                <br />
                                <br />
                                <span itemProp="email">{process.env.REACT_APP_EMAIL}</span>
                            </div>
                            <div className="col-sm">
                                Графік роботи <br /><br />
                                Пн-Пт з 8 до 18 <br />
                                Сб-Нд - дзвінки, чат
                            </div>
                        </div>
                    </div>

                    <div style={{
                        textAlign: "center",
                        margin: "20px auto",
                        height: "600px",
                        maxWidth: "100%",
                    }}>
                        <iframe width="1140" height="350" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://www.openstreetmap.org/export/embed.html?bbox=26.241118311882023%2C50.55545790177917%2C26.245576143264774%2C50.55696940596718&amp;layer=mapnik&amp;marker=50.55621280790007%2C26.243347227573395"></iframe>
                    </div>
                </div>
                <Footer />
            </Fragment>
        )
    }
}
